import { useCallback } from "react"

import { startVideo } from "../cloudroomHelpers/chimeAudioVideoHelpers"

const useLocalAVControls = ({
  audioVideo,
  configureMicrophone,
  lowBandwidthStudent,
  handleError,
}) => {
  const muteLocalAudio = useCallback(() => {
    if (audioVideo.realtimeIsLocalAudioMuted()) return

    audioVideo.realtimeMuteLocalAudio()
    audioVideo.stopAudioInput()
  }, [audioVideo])

  const unmuteLocalAudio = useCallback(async () => {
    if (!audioVideo.realtimeIsLocalAudioMuted()) return

    await configureMicrophone()
    audioVideo.realtimeUnmuteLocalAudio()
  }, [audioVideo, configureMicrophone])

  const muteLocalVideo = useCallback(() => {
    audioVideo.stopLocalVideoTile()
    audioVideo.stopVideoInput()
  }, [audioVideo])

  const unmuteLocalVideo = useCallback(() => {
    if (lowBandwidthStudent) return

    startVideo(audioVideo, handleError)
  }, [audioVideo, lowBandwidthStudent, handleError])

  return { muteLocalAudio, unmuteLocalAudio, muteLocalVideo, unmuteLocalVideo }
}

export default useLocalAVControls
